import InputAction from './input-action';

export default InputAction;
